module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg31.7539e647.jpg";